import { UserDTO } from "./User";

export enum MembershipStatus {
  Active = "Active",
  Suspended = "Suspended",
  Expired = "Expired",
}

export type Membership = {
  id: string;
  price: number;
  bookingsAvailable: number;
  bookingsLeft: number;
  expiring: string;
  userId: string;
  structureId: string;
  status: MembershipStatus;
  user?: UserDTO;
  createdAt?: string;
  updatedAt?: string;
};

export type CreateMembershipDTO = {
  userId: string;
  price: number;
  bookingsAvailable: number;
  expiring: string;
};

export type UpdateMembershipDTO = {
  price?: number;
  bookingsLeft?: number;
  expiring?: string;
  status?: MembershipStatus;
};